<template>
    <div>
        <breadcrumb :routerList="[{to:'/leaveoffice/leaveoffice',title:'离职交接'},{title:'离职申请'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="被交接人" class="h-elformWrap-1">
                            <el-input readonly
                                      v-model="formInline.leaveName"
                                      :title="formInline.leaveName">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="交接说明" class="h-elformWrap-1 yh-inputborder">
                            <el-input type="textarea"
                                      readonly
                                      :rows="5"
                                      placeholder="请输入"
                                      v-model="formInline.leaveExplain"
                                      :title="formInline.leaveExplain">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="承接人" class="h-elformWrap-1">
                            <el-input readonly
                                      placeholder="请选择"
                                      v-model="formInline.handoverName"
                                      :title="formInline.handoverName">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="h-table h-mrt30 h-rowBox" style="margin-top: 0.2rem;">
                    <div class="h-pieceTitle2 hang">
                        <h1 class="h1">审批意见</h1>
                        <el-form :model="formLabelAlign" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="审批意见" class="h-elformWrap-1" :required="true"
                                          style="margin:30px 0 40px 29px">
                                <el-input v-model="shenhetext" placeholder="请输入"
                                          class="zidaoO"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>

            </div>
            <div class="apprButton" style="display: flex;justify-content: center;align-items: center;margin-top: 0.5rem">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
                <el-button v-if="$route.query.taskstatus == 0" class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
                <el-button v-if="$route.query.taskstatus == 0" class="h-btn h-bBtn h-bggreen" @click="auditPass">通过</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="findDetail">查看审批详情</el-button>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        components: {},
        data() {
            return {
                formLabelAlign:{},
                formInline: {
                    id: '',
                    leaveCode: '',
                    leaveName: '',
                    leaveExplain: '',
                    handoverCode: '',
                    handoverName: '',
                    instid: '',
                    taskid: '',
                    optflag: '',
                    yijianMsg: '',
                    aaa: ''
                },
                instid: '',
                shenhetext: '',
                showhistory:false,
            }
        },
        created() {
            this.instid = this.$route.query.instid;
            this.query();
        },
        methods: {
            query(){
                this.formInline.id = this.$route.query.ywid;
                this.formInline.instid = this.$route.query.instid;
                this.formInline.taskid = this.$route.query.taskid;
                ss.leaveService.selectSPData(this.formInline).then(rd=>{
                    this.formInline = rd;
                })
            },
            //查看审批流详情
            findDetail() {
                this.showhistory = true;
            },
            auditPass() {
                this.$msg.confirm("确认通过? 通过后此离职人的代办审批将推送到交接人的账号！", () => {
                    this.formInline.aaa = 2
                    this.formInline.optflag = '审核通过';
                    this.formInline.yijianMsg = this.shenhetext;
                    ss.leaveService.auditLeave(this.formInline).then(rd=>{
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            this.$router.push({path:'/personal/dealCenter'})
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                });
            },
            auditFail() {
                if (this.shenhetext == '') {
                    this.$msg.msge("请输入审批意见！");
                    return false;
                }
                this.$msg.confirm("确认驳回？", () => {
                    this.formInline.aaa = 1
                    this.formInline.optflag = '审核被驳回';
                    this.formInline.yijianMsg = this.shenhetext;
                    ss.leaveService.auditLeave(this.formInline).then(rd=>{
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            this.$router.push({path:'/personal/dealCenter'})
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                });
            },
            returnTable() {
                this.$router.push({path: '/personal/dealCenter'});
            }
        }
    }
</script>
<style>
    .yh-inputborder .el-textarea__inner{
        border: 1px solid #dedede;
    }
</style>
